var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-action-sheet',{model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('van-area',{attrs:{"value":_vm.fieldValue,"area-list":_vm.areaList,"columnsNum":_vm.columnsNum},on:{"confirm":_vm.onConfirm,"cancel":_vm.onCancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }